import { render, staticRenderFns } from "./Proceeds.vue?vue&type=template&id=23f58d8b&scoped=true"
import script from "./Proceeds.vue?vue&type=script&lang=js"
export * from "./Proceeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f58d8b",
  null
  
)

export default component.exports